import { createAction } from "redux-actions";

export default createAction("MARK_BLOCK");
